import { Component } from '@angular/core';

@Component({
    selector: 'close-icon',
    template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 27"><g fill-rule="evenodd"><path d="M4.536 0l22.627 22.627-3.536 3.535L1 3.535z"></path><path d="M.92 23.046L23.545.42l3.535 3.534L4.455 26.58z"></path></g></svg>'
})
export class CloseIcon {}
